import React, { useState } from 'react'
import { PermissoesInterface } from '../ImportBackend/Interfaces/SistemaModuloPermissaoInterfaces'

export interface LoginStateInterface {
  token: string
  nome: string
  logado: boolean
  idUsuario: number
  permissoes: Array<PermissoesInterface>
}

export default function useLoginState () {

  const [loginState, setLoginState] =
    useState<LoginStateInterface>( {
      token: '',
      nome: '',
      idUsuario: 0,
      logado: false,
      permissoes: []
    } )

  return { loginState, setLoginState }

}